import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { LuBellRing } from "react-icons/lu";
import { useLanguage } from "../../../Language/LanguageContext";
import Switch from "@mui/material/Switch";
import { styled } from '@mui/material/styles';
const UserNav = (props) => {
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const location = useLocation();

  const isOperatorPage = location.pathname.startsWith("/user/drone");
  const isPilotPage = location.pathname.startsWith("/user/pilot");
  const isOperationPage = location.pathname.startsWith("/user/operation");
  const operatorStyle = isOperatorPage
    ? {
        textDecoration: "underline  5px",
        textUnderlineOffset: "8px",
        fontFamily,
      }
    : { textDecoration: "none", fontFamily };
  const pilotrStyle = isPilotPage
    ? {
        textDecoration: "underline  5px",
        textUnderlineOffset: "8px",
        fontFamily,
      }
    : { textDecoration: "none", fontFamily };
  const operationStyle = isOperationPage
    ? {
        textDecoration: "underline  5px",
        textUnderlineOffset: "8px",
        fontFamily,
      }
    : { textDecoration: "none", fontFamily };

  const handleLanguageSwitch = (event) => {
    changeLanguage(event.target.checked ? "th" : "en");
  };

  const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    color: 'white', // thumb color when OFF
    '&.Mui-checked': {
      color: 'white', // thumb color when ON
      '& + .MuiSwitch-track': {
        backgroundColor: '#ffffffff', // track color when ON
      },
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#ffffffff', // track color when OFF
  },
}));

  return (
    <Nav
      className="navbar navbar-expand navbar-dark "
      style={{
        height: "6.75vh",
        backgroundColor:
          "linear-gradient(90deg,rgba(104, 24, 158, 1) 0%, rgba(150, 48, 171, 1) 50%, rgba(201, 0, 201, 1) 100%)",
        backgroundImage:
          "linear-gradient(90deg,rgba(212, 147, 255, 1) 0%, rgba(134, 70, 147, 1) 50%, rgb(159, 9, 159) 100%)",

        padding: "0.7rem 2rem",
        position: "relative",
        fontFamily,
      }}
    >
      <Link to={"/home"} 
      // className="logo-text"
      >
      {/* <div style={{backgroundColor:"white", marginTop:"0px", borderRadius:"100px"}}> */}
        <img
          src={props.logo_dronewhite}
          alt="profile-img"
          style={{
            // margin: "5px",
            // boxShadow:"rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
            height: "125px",
            // filter: "invert(1) grayscale(1) brightness(2)",
          }}
        />
      {/* </div> */}
        
      </Link>
      &nbsp;&nbsp;
      <div className="navbar-nav">
        <NavDropdown
          show={props.show}
          onMouseEnter={props.showDropdown}
          onMouseLeave={props.hideDropdown}
          title={
            <div
              className="navbar-nav ml-auto nav-section"
              style={{
                color: "#ffffff",
                //position: "absolute",
              }}
            >
              <li className="nav-item activenav " style={operatorStyle}>
                {t("operator")}
              </li>{" "}
            </div>
          }
          className="nav-dropdown dropdown"
          style={{
            color: "#EDEDED",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "24px",
            marginTop: "7px",
            lineHeight: "32px",

            //left: "1670px",
            top: "0px",
          }}
        >
          <NavDropdown.Item eventKey="4.1" href="/user/drone/regisDrone">
            {t("registerdrone")}
          </NavDropdown.Item>
          <NavDropdown.Item eventKey="4.2" href="/user/drone/regisremote">
            {t("registerremoteid")}
          </NavDropdown.Item>
          <NavDropdown.Item eventKey="4.3" href="/user/drone/statusDrone">
            {t("managedrone")}
          </NavDropdown.Item>
          <NavDropdown.Item eventKey="4.4" href="/user/drone/pilotstatus">
            {t("managepilot")}
          </NavDropdown.Item>
          <NavDropdown.Item
            //disabled
            eventKey="4.5"
            href="/user/drone/statusflightdrone"
          >
            {t("statusoperation")}
          </NavDropdown.Item>
        </NavDropdown>
        <NavDropdown
          show={props.showPilot}
          onMouseEnter={props.showDropdownPilot}
          onMouseLeave={props.hideDropdownPilot}
          title={
            <div
              className="navbar-nav ml-auto nav-section"
              style={{
                color: "#ffffff",
                //position: "absolute",
              }}
            >
              <li className="nav-item activenav" style={pilotrStyle}>
                {t("pilot")}
              </li>{" "}
            </div>
          }
          className="nav-dropdown"
          style={{
            color: "#EDEDED",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "24px",
            marginTop: "7px",
            lineHeight: "32px",
            //left: "120px",
            top: "0px",
          }}
        >
          <div>
            <NavDropdown.Item eventKey="4.1" href="/user/pilot/regispilot">
              {t("registerpilotopen")}
            </NavDropdown.Item>
            <NavDropdown.Item
              eventKey="4.2"
              href="/user/pilot/regispilotspacific"
            >
              {t("registerpilotspacific")}
            </NavDropdown.Item>
            <NavDropdown.Item
              eventKey="4.3"
              href="/user/pilot/statusoperatingpilot"
            >
              {t("manageflightoperation")}
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="4.4" href="/user/pilot/statuspilot">
              {t("historyflight")}
            </NavDropdown.Item>
          </div>
        </NavDropdown>
        <div className="navbar-nav ml-auto">
          <NavDropdown
            show={props.showOperation}
            onMouseEnter={props.showDropdownOperation}
            onMouseLeave={props.hideDropdownOperation}
            title={
              <div
                className="navbar-nav ml-auto nav-section"
                style={{
                  color: "#ffffff",

                  //position: "absolute",
                }}
              >
                <li className="nav-item activenav" style={operationStyle}>
                  {t("operation")}
                </li>{" "}
              </div>
            }
            className="nav-dropdown"
            style={{
              color: "red",

              fontFamily: "Montserrat",
              fontStyle: "normal",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "32px",
              marginTop: "7px",
              //left: "200px",
              transform: "none",
              top: "0px",
            }}
          >
            <NavDropdown.Item
              eventKey="4.2"
              href="/user/operation/polygonLeaflet"
            >
              {t("droneoperation")}
            </NavDropdown.Item>
            <NavDropdown.Item
              eventKey="4.3"
              href="/user/operation/joinoperation"
            >
              {t("joinoperation")}
            </NavDropdown.Item>
            <NavDropdown.Item
              //disabled
              eventKey="4.6"
              href="/user/operation/operationdisplays"
            >
              {t("opeartiondisplay")}
            </NavDropdown.Item>
            <NavDropdown.Item
              //disabled
              eventKey="4.7"
              href="/user/operation/dronemonitor"
            >
              {t("monitoring")}
            </NavDropdown.Item>
            {/* <NavDropdown.Item
              disabled
              eventKey="4.8"
              href="/user/operation/dronemonitorsocket"
            >
              Monitoring WebSocket
            </NavDropdown.Item> */}
          </NavDropdown>
        </div>
      </div>
      {props.currentUser ? (
        <div className="navbar-nav ml-auto">
          <div style={{position:"relative",right:"100%"}}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                position: "absolute",
                left: "82%",
                top: "25%",
                borderRadius: "10px",
                height: "50%",
                color: "white",
              }}
            >
              <span>EN</span>
              <CustomSwitch
                checked={language === "th"}
                onChange={handleLanguageSwitch}
                // color="primary"
                // style={{color:"red", backgroundColor:"blue"}}
              />
              <span>TH</span>
            </div>
          </div>
          <NavDropdown
            show={props.showProfile}
            onMouseEnter={props.showDropdownProfile}
            onMouseLeave={props.hideDropdownProfile}
            title={
              <div style={{ display: "flex" }}>
                <div
                  className="navbar-nav ml-auto"
                  style={{
                    color: "#ffffff",

                    //position: "absolute",
                    //top: "-5px",
                    fontSize: "26px",
                    lineHeight: "32px",
                    fontWeight: "400",
                    fontStyle: "normal",
                  }}
                >
                  <li className="nav-item activenav">
                    {props.currentUser.f_name === null
                      ? props.currentUser.email.substring(0, 8)
                      : props.currentUser.f_name.substring(0, 8)}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </li>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ left: "100%" }}>
                    <div
                      className="navbar-nav ml-auto"
                      style={{
                        position: "absolute",
                        top: "10%",
                        //left: "6%",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#023E8A",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "26px",
                        color: "white",
                        borderRadius: "50%",
                      }}
                    >
                      {props.currentUser.f_name === null
                        ? props.currentUser.email.charAt(0)
                        : props.currentUser.f_name.charAt(0)}
                    </div>
                  </div>
                </div>
              </div>
            }
            style={{
              color: "#EDEDED",
              fontFamily: "Kanit",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "34px",
              //top: "18px",
              //left: "1670px",
              //position: "absolute",
              right: "25%",
              width: "100%",
            }}
          >
            <NavDropdown.Item eventKey="4.1" href="/profile/profileuser">
              {t("profile")}
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="4.2" onClick={() => props.logOut()}>
              {t("logout")}
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      ) : (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            {/* <button
  type="button"
  className="text-blue-800"
  onClick={() => keycloak.login()}
>
  Login
</button>*/}
            <Link to={"/login"} className="nav-link" style={{ color: "white" }}>
              Login
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to={"/register"}
              className="nav-link"
              style={{ color: "white" }}
            >
              Sign Up
            </Link>
          </li>
        </div>
      )}
    </Nav>
  );
};

export default UserNav;
